module.exports = __webpack_public_path__ + "img/illustration-accueil.1a61d023.png";